import React from 'react';
import useFeatureToggleService from 'feature-toggle';
import { DateFieldLayoutProps } from 'ui-builder';
import { cn } from 'shadcn-ui';

function LegacyDateFieldLayout(props: DateFieldLayoutProps) {
  if (props.value) {
    return (
      <span>
        {props.prefix ? `${props.prefix} ` : ''}
        {props.value}
      </span>
    );
  } else {
    return props.noDataMessage ? (<span>{props.noDataMessage}</span>) : null;
  }
}

function ShadcnDateFieldLayout(props: DateFieldLayoutProps) {
  if (props.value) {
    return (
      <span className={cn('text-sm text-gray-800', props.className)}>
        {props.prefix ? `${props.prefix} ` : ''}
        {props.value}
      </span>
    );
  } else {
    return props.noDataMessage
      ? (<span className={cn('text-sm text-gray-800', props.className)}>{props.noDataMessage}</span>)
      : null;
  }
}

export default function DateFieldLayout(props: DateFieldLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnDateFieldLayout {...props} />;
  } else {
    return <LegacyDateFieldLayout {...props} />;
  }
}
